// @flow
import { handleActions, type ActionType } from 'redux-actions';
import {
  requestSearchResults,
  navigateSearchResults,
  receiveSearchResults,
  clearSearch,
  submitSearch,
} from './searchActions';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';
import { Map } from 'immutable';

export type SearchState = {
  pages: Map<number, AsyncValueType<Array<Id>>>,
  queries: Map<number, { [string]: string }>,
  currentPage: number,
  totalPages: ?number,
};
const defaultState = {
  pages: Map(),
  queries: Map(),
  currentPage: 1,
  totalPages: null,
};

export default {
  search: handleActions(
    {
      [submitSearch.toString()]: (
        state: SearchState,
        action: ActionType<submitSearch>
      ) => {
        const baseQuery = action.payload;
        const currentPage = 1;

        return {
          pages: Map().set(currentPage, AsyncValues.Pending),
          queries: Map().set(currentPage, baseQuery),
          currentPage,
          totalPages: null,
        };
      },

      [clearSearch.toString()]: () => defaultState,

      [requestSearchResults.toString()]: (
        state: SearchState,
        action: ActionType<requestSearchResults>
      ) => {
        const { page: currentPage, query } = action.payload;

        return {
          ...state,
          currentPage,
          pages: state.pages.set(currentPage, AsyncValues.Pending),
          queries: state.queries.set(currentPage, query),
        };
      },

      [navigateSearchResults.toString()]: (
        state: SearchState,
        action: ActionType<requestSearchResults>
      ) => {
        const { page: currentPage, query } = action.payload;

        return {
          ...state,
          currentPage,
          pages: state.pages.has(currentPage)
            ? state.pages
            : state.pages.set(currentPage, AsyncValues.Pending),
          queries: state.queries.set(currentPage, query),
        };
      },

      [receiveSearchResults.toString()]: (
        state: SearchState,
        action: ActionType<receiveSearchResults>
      ) => {
        const { items, totalPages } = action.payload;
        const { currentPage, pages } = state;

        return {
          ...state,
          pages: pages.set(currentPage, items),
          totalPages: totalPages != null ? totalPages : state.totalPages,
        };
      },
    },
    defaultState
  ),
};

export function isSearching(state: SearchState): boolean {
  return state !== defaultState;
}



// WEBPACK FOOTER //
// ./src/containers/search/searchReducer.js